import { productGalleryTabsSX } from '@/components/blocks/ProductDetails/styles/productGalleryTabs';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { IconButton, Stack, Typography } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const ProductGalleryNavigation = ({
	totalSlides,
	currentSlide,
	onPrev,
	onNext,
	id,
	className,
	prevClassName,
	nextClassName,
}: {
	totalSlides: number;
	currentSlide: number;
	onPrev: () => void;
	onNext: () => void;
	id: string;
	className: string;
	prevClassName: string;
	nextClassName: string;
}) => {
	if (totalSlides <= 1) return null;

	return (
		// eslint-disable-next-line react/forbid-component-props
		<Stack
			direction="row"
			spacing={0}
			sx={productGalleryTabsSX.navigation}
			id={id}
			className={className}
		>
			{/* eslint-disable-next-line react/forbid-component-props */}
			<IconButton
				type="navigation"
				sx={productGalleryTabsSX.navigationButton}
				onClick={onPrev}
				className={prevClassName}
			>
				<DynamicIcon name={MATERIAL_SYMBOL_ICONS.chevronLeft} />
			</IconButton>

			<Typography variant="bodyBaseline" color="grey.300">
				{`${currentSlide + 1}/${totalSlides}`}
			</Typography>

			{/* eslint-disable-next-line react/forbid-component-props */}
			<IconButton
				type="navigation"
				sx={productGalleryTabsSX.navigationButton}
				onClick={onNext}
				className={nextClassName}
			>
				<DynamicIcon name={MATERIAL_SYMBOL_ICONS.chevronRight} />
			</IconButton>
		</Stack>
	);
};
